import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AppContainerModule, AppContainerOptions, LanguageService, MydocmaServiceWorkerModule  } from '@mydocma/app-container';
import {CoStructureSyncService} from 'projects/mydocma/co/src/lib/common/bp/structure/co-structure-sync.service';
import {CoStructureSyncViewService} from 'projects/mydocma/co/src/lib/common/bp/structure/co-structure-sync-view.service';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {MainComponent} from './main/main.component';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {AuthModule} from '@mydocma/auth';
import {ProjectModule, ProjectStructureService} from '@mydocma/project';
import {CustomerModule} from '@mydocma/customer';
import {MediaQueryService, MediatorService} from '@mydocma/core';
import {IModuleTranslationOptions, ModuleTranslateLoader} from '@larscom/ngx-translate-module-loader';
import {TranslateLoader, TranslateModule, TranslateService} from '@ngx-translate/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ResizeModule} from '@mydocma/component-library';
import {RedirectPageComponent} from './redirect-page/redirect-page.component';
import {MydocmaTaskModule} from '@mydocma/task';
import {registerLocaleData} from '@angular/common';
import localeDE from '@angular/common/locales/de';
import localeEN from '@angular/common/locales/en-GB';
import {CustomMatIconModule} from '@mydocma/component-library/src/lib/custom-mat-icon';
import { CoPermissionsService } from 'projects/mydocma/co/src/lib/co-permissions.service';
import { CoEventService } from 'projects/mydocma/co/src/lib/co-event.service';
import { BpSideNavbarModule } from 'projects/mydocma/co/src/lib/side-navbar/side-navbar.module';
import { CoCommonModule, BpViewService } from '@mydocma/co/src/lib/common';
import { RouterModule } from '@angular/router';
import { BpRoutingService } from 'projects/mydocma/co/src/lib/bp-routing/bp-routing.service';
import {MydocmaDynamicFormModule} from "@mydocma/dynamic-form";
import {MatLegacyTabsModule} from "@angular/material/legacy-tabs";
import {MAT_LEGACY_DIALOG_DEFAULT_OPTIONS as MAT_DIALOG_DEFAULT_OPTIONS} from "@angular/material/legacy-dialog";
import { ErrorHandler } from '@angular/core';
import { GlobalErrorHandler } from './global-error-handler';
import { Logger } from '@mydocma/common/src/lib/logger';

export function createTranslateLoader(http: HttpClient) {
  const baseTranslateUrl = './assets/i18n';
  return new ModuleTranslateLoader(http, <IModuleTranslationOptions> {
    modules: [
      {baseTranslateUrl},

      {moduleName: 'co', baseTranslateUrl},
      {moduleName: 'tv', baseTranslateUrl},
      {moduleName: 'app-container', baseTranslateUrl},
      {moduleName: 'project', baseTranslateUrl},
      {moduleName: 'comp-lib', baseTranslateUrl},
      {moduleName: 'customer', baseTranslateUrl},
      {moduleName: 'bim', baseTranslateUrl},
      {moduleName: 'form', baseTranslateUrl},
    ],
  });
}

@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    RedirectPageComponent,


  ],
  imports: [
    RouterModule,
    MydocmaTaskModule,
    BrowserModule,
    MydocmaServiceWorkerModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    AppContainerModule,
    ResizeModule,
    AuthModule.forRoot(),
    CustomerModule.forRoot(),
    ProjectModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient],
      },
    }),
    CustomMatIconModule,
    CoCommonModule,
    BpSideNavbarModule,
    MydocmaDynamicFormModule,
    CoCommonModule,
    MatLegacyTabsModule,

  ],
  providers: [
    AppContainerOptions,
    Logger,
    MediatorService,
    MediaQueryService,
    ProjectStructureService,
    CoPermissionsService,
    BpRoutingService,
    CoEventService,
    BpViewService,
    CoStructureSyncService,
    CoStructureSyncViewService,
    // prevents buttons from staying focused (darker shade) after closing dialogs
    {provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: {restoreFocus: false}},
    {provide: ErrorHandler, useClass: GlobalErrorHandler}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(
    languageService: LanguageService,
    translateService: TranslateService,
  ) {
    languageService.setLanguages([
      {id: 'en', name: 'English'},
      {id: 'de', name: 'Deutsch'}
    ]);

    registerLocaleData(localeDE, 'de');
    const t = localeEN;

    localeEN[10][1] = 'yyyy-MM-dd';
    localeEN[10][0] = 'yy-MM-dd';
    registerLocaleData(localeEN, 'en');
    //

    translateService.addLangs(['en', 'de']);
    translateService.setDefaultLang('de');
    translateService.use('de');
  }
}

